import React from 'react';

import styles from '../../assets/styles/CreditLinePageTitle.module.scss';

const CreditLinePageTitle = ({ children, customClass }) => {
  return <p className={`${styles.CreditLinePageTitle} ${customClass}`}>{children}</p>;
};
export default CreditLinePageTitle;
